import React, { useState } from "react";
import axios from "axios";
import { API } from "../lib/brand";
import BrandMark from "../components/BrandMark";
import { Send, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in all fields");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
      toast.success("Message sent — go raibh maith agat");
      setForm({ name: "", email: "", message: "" });
    } catch (e) {
      toast.error("Could not send. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page" className="pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <div className="text-[11px] tracking-[0.4em] uppercase text-[#279153] mb-3">Get in touch</div>
        <h1 className="font-serif-display text-5xl text-white mb-6">Write to the studio</h1>
        <p className="text-base text-[#95A89C] leading-relaxed max-w-2xl mb-4">
          Commissions, collaborations, or simply a hello — every message reaches the artist directly.
        </p>
        <p className="text-sm text-[#95A89C] mb-12">
          Prefer email?{" "}
          <a href="mailto:hello@gracreation.com" data-testid="contact-email-link" className="text-[#279153] hover:underline">
            hello@gracreation.com
          </a>
        </p>

        {sent ? (
          <div data-testid="contact-success" className="p-10 bg-[#09120C] border border-[#1A2B20] text-center">
            <BrandMark variant="knot" className="h-14 w-14 mx-auto mb-6 block" />
            <h2 className="font-serif-display text-3xl text-white mb-3">Go raibh maith agat</h2>
            <p className="text-[#95A89C] mb-6">Your message has been delivered. The studio will be in touch soon.</p>
            <button
              data-testid="contact-send-another"
              onClick={() => setSent(false)}
              className="px-5 py-2.5 border border-white/30 text-white text-xs tracking-[0.3em] uppercase hover:border-[#279153] hover:text-[#279153]"
            >
              Send another
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="p-8 bg-[#09120C] border border-[#1A2B20] space-y-5">
            <div className="grid sm:grid-cols-2 gap-5">
              <div>
                <label className="block text-[10px] tracking-[0.3em] uppercase text-[#5C7064] mb-2">Name</label>
                <input
                  data-testid="contact-name"
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full px-4 py-3 bg-[#050605] border border-[#1A2B20] text-white text-sm focus:border-[#279153] focus:outline-none"
                />
              </div>
              <div>
                <label className="block text-[10px] tracking-[0.3em] uppercase text-[#5C7064] mb-2">Email</label>
                <input
                  data-testid="contact-email"
                  type="email"
                  required
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="w-full px-4 py-3 bg-[#050605] border border-[#1A2B20] text-white text-sm focus:border-[#279153] focus:outline-none"
                />
              </div>
            </div>
            <div>
              <label className="block text-[10px] tracking-[0.3em] uppercase text-[#5C7064] mb-2">Message</label>
              <textarea
                data-testid="contact-message"
                required
                rows={6}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full px-4 py-3 bg-[#050605] border border-[#1A2B20] text-white text-sm focus:border-[#279153] focus:outline-none resize-none"
              />
            </div>
            <button
              type="submit"
              data-testid="contact-submit"
              disabled={loading}
              className="flex items-center justify-center gap-3 px-7 py-4 bg-[#1E7040] hover:bg-[#165932] disabled:opacity-50 text-white text-xs tracking-[0.3em] uppercase"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
              {loading ? "Sending…" : "Send message"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
